
import React from "react";
import editorange from 'assets/images/icon/edit-orange.png'

const GeneralInformationSection = () => {

    return (
        <div>
            <div className='d-flex align-items-center justify-content-between'>
                <h2 className='sub-title'>General Information</h2>
                <button className='border-0 bg-transparent'>
                    <img className='cursor-pointer' src={editorange} alt="editorange" />
                </button>
            </div>
            <div className='general-information-section border-bottom pb-4 mb-4'>
                <div>
                    <p className='m-0 title'>Legal Name</p>
                    <p className='m-0 sub-titles'>Demo Smith</p>
                </div>
                <div>
                    <p className='m-0 title'>DBA Name</p>
                    <p className='m-0 sub-titles'>Paper Check</p>
                </div>
                <div>
                    <p className='m-0 title'>Entity Type</p>
                    <p className='m-0 sub-titles'>****** 4742</p>
                </div>
                <div>
                    <p className='m-0 title'>Industry</p>
                    <p className='m-0 sub-titles'>Nov 07, 1985</p>
                </div>
                <div>
                    <p className='m-0 title'>Default Pay Frequency</p>
                    <p className='m-0 sub-titles'>Nov 07, 2019</p>
                </div>
                <div>
                    <p className='m-0 title'>Processing Period</p>
                    <p className='m-0 sub-titles'>Three-Day</p>
                </div>
                <div>
                    <p className='m-0 title'>Start Date</p>
                    <p className='m-0 sub-titles'>Jul 05, 2024</p>
                </div>
            </div>
            <div>
                <h2 className='sub-title'>Contact Information</h2>
                <div className='general-information-section'>
                    <div>
                        <p className='m-0 title'>Address</p>
                        <p className='m-0 sub-titles address-details'>2450 St Rose Pkwy Suite 120
                            Henderson, NV, 89074, US</p>
                    </div>
                    <div>
                        <p className='m-0 title'>Email</p>
                        <p className='m-0 sub-titles'>doug@nlync.net</p>
                    </div>
                    <div>
                        <p className='m-0 title'>Phone</p>
                        <p className='m-0 sub-titles'>8556698728</p>
                    </div>
                    <div>
                        <p className='m-0 title'>Website</p>
                        <p className='m-0 sub-titles'>nlync.net</p>
                    </div>
                </div>
            </div>
        </div>
    )

}

export default GeneralInformationSection;